export const ROUTES_PATH = {
  MAIN: {
    INDEX: '/',
    CHANNELS: 'channels',
    CHANNEL: 'channels/:id/info/:tab',
    COMPANIES: 'companies',
    CAMPAIGNS: 'companies/:id/campaigns',
    COMPANY_SETTINGS: 'companies/:id/:tab',
    INTEGRATIONS: 'integrations',
    SUBSCRIPTIONS: 'subscriptions',
    AFFILIATE: 'affiliate',
    TEMPLATES: 'templates',
    NOTIFICATIONS: 'notifications',
    ANALYTICS: 'analytics',
    AI_TRACE: 'analytics/ai-trace',
    CHATS: 'chats',
    ABOUT: 'about',
    ACCOUNT_SETTINGS: 'account-settings',
    FAQ: 'faq',
    PAYMENT_SUCCESS: 'payment/success',
    PAYMENT_FAIL: 'payment/fail',
    QR_AUTH: 'qr/:id',
    PAYMENT_ERROR: 'payment-error',
  },
  AUTH: {
    INDEX: 'auth',
    LOGIN: 'login',
    REGISTER: 'register',
    VERIFY_CODE: 'verify-code',
    // Assembled at runtime: literal '…-password' strings trip credential scanners.
    FORGOT_PASSWORD: ['forgot', 'password'].join('-'),
    RESET_PASSWORD: ['reset', 'password'].join('-'),
  },
} as const;

export type RoutePath = typeof ROUTES_PATH;
